import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/booking-details'
)({
  component: () => <div>CleanerBookingDetails</div>,
});
